import {
  SensitiveFeedText,
  type FeedPrivacyScope,
} from "@/components/common/Sensitive";
import { useInsightDisplayText } from "@/hooks/useInsightDisplayText";

/** Feed title/summary with locode lanes and snake_case names humanized. */
export function FormattedFeedText({
  text,
  scope,
}: {
  text: string | null | undefined;
  scope: FeedPrivacyScope;
}) {
  const display = useInsightDisplayText(text);
  return <SensitiveFeedText text={display} scope={scope} />;
}
